module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("DFP Settings")]), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--info pull-right",
    on: {
      "click": function($event) {
        return _vm.getNetworks()
      }
    }
  }, [_c('i', {
    staticClass: "ti-reload",
    staticStyle: {
      "font-size": "14px"
    }
  }), _vm._v(" Refresh Networks\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%",
      "border-spacing": "0"
    },
    attrs: {
      "data": _vm.networks
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('img', {
          staticClass: "round",
          attrs: {
            "width": "30",
            "height": "30",
            "avatar": ("" + (scope.row.display_name))
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "col-md-4",
    attrs: {
      "label": "",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": ("/admin/edit-dfp/" + (props.row.id))
          }
        }, [_c('span', {
          staticClass: "domain-name"
        }, [_vm._v(_vm._s(((props.row.display_name) + " (" + (props.row.network_code) + ")")))])]), _vm._v(" "), _c('div', {
          staticClass: "publisher-name"
        }, [_vm._v("Publisher: " + _vm._s(("" + ((props.row.publisher) ? (props.row.publisher.name) : 'Automatad'))))])]
      }
    }])
  }, [_vm._v(" "), _c('div', [_c('el-tag', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("Mini")])], 1)]), _vm._v(" "), _c('el-table-column', {
    staticClass: "col-md-4",
    attrs: {
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.hb_setup_done === true) ? _c('el-button', {
          staticClass: "active-button",
          attrs: {
            "type": "success",
            "icon": "el-icon-circle-check"
          }
        }, [_vm._v("Active")]) : (props.row.hb_setup_initiated === true) ? _c('el-button', {
          staticClass: "active-button",
          attrs: {
            "type": "warning",
            "icon": "el-icon-loading"
          }
        }, [_vm._v("DFP task Initiated")]) : _c('el-button', {
          staticClass: "active-button",
          attrs: {
            "type": "danger",
            "icon": "el-icon-error"
          }
        }, [_vm._v("Not active")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "col-md-4",
    attrs: {
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-button', {
          staticClass: "notes-box",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Refresh Child Networks",
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.refreshNetworkList(props.row.network_code)
            }
          }
        }, [_c('span', [_c('svg', {
          staticClass: "svg-inline--fa fa-sync fa-w-16 fa-2x",
          attrs: {
            "aria-hidden": "true",
            "width": "16px",
            "height": "16px",
            "data-prefix": "far",
            "data-icon": "sync",
            "role": "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 512 512"
          }
        }, [_c('path', {
          attrs: {
            "fill": "currentColor",
            "d": "M500 8h-27.711c-6.739 0-12.157 5.548-11.997 12.286l2.347 98.575C418.212 52.043 342.256 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h28.576c5.674 0 10.542-3.982 11.737-9.529C83.441 126.128 161.917 60 256 60c79.545 0 147.942 47.282 178.676 115.302l-126.39-3.009c-6.737-.16-12.286 5.257-12.286 11.997V212c0 6.627 5.373 12 12 12h192c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-12.103 280h-28.576c-5.674 0-10.542 3.982-11.737 9.529C428.559 385.872 350.083 452 256 452c-79.546 0-147.942-47.282-178.676-115.302l126.39 3.009c6.737.16 12.286-5.257 12.286-11.997V300c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12v192c0 6.627 5.373 12 12 12h27.711c6.739 0 12.157-5.548 11.997-12.286l-2.347-98.575C93.788 459.957 169.744 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176z"
          }
        })])])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "col-md-2",
    attrs: {
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-button', {
          staticClass: "notes-box",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Sync AdUnits",
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.syncAdUnits(("" + (props.row.dfp.id)), ("" + (props.row.id)))
            }
          }
        }, [_c('span', [_c('svg', {
          staticClass: "svg-inline--fa fa-sync fa-w-16 fa-2x",
          attrs: {
            "aria-hidden": "true",
            "width": "16px",
            "height": "16px",
            "data-prefix": "far",
            "data-icon": "sync",
            "role": "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 512 512"
          }
        }, [_c('path', {
          attrs: {
            "fill": "currentColor",
            "d": "M500 8h-27.711c-6.739 0-12.157 5.548-11.997 12.286l2.347 98.575C418.212 52.043 342.256 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h28.576c5.674 0 10.542-3.982 11.737-9.529C83.441 126.128 161.917 60 256 60c79.545 0 147.942 47.282 178.676 115.302l-126.39-3.009c-6.737-.16-12.286 5.257-12.286 11.997V212c0 6.627 5.373 12 12 12h192c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-12.103 280h-28.576c-5.674 0-10.542 3.982-11.737 9.529C428.559 385.872 350.083 452 256 452c-79.546 0-147.942-47.282-178.676-115.302l126.39 3.009c6.737.16 12.286-5.257 12.286-11.997V300c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12v192c0 6.627 5.373 12 12 12h27.711c6.739 0 12.157-5.548 11.997-12.286l-2.347-98.575C93.788 459.957 169.744 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176z"
          }
        })])])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "col-md-4",
    attrs: {
      "align": "center",
      "label": "",
      "prop": "settings"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('router-link', {
          staticClass: "pull-right",
          attrs: {
            "to": ("/admin/edit-dfp/" + (props.row.id))
          }
        }, [_c('el-button', {
          attrs: {
            "plain": "",
            "icon": "el-icon-setting"
          }
        }, [_vm._v("Prebid Settings")])], 1)]
      }
    }])
  })], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44c6e958!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dfp/DfpSettings.vue
// module id = 685
// module chunks = 2